import BaseAPI from "../api";

const path = 'auth'

interface loginType {
    email: string;
    password: string;
}
interface refreshToken {
    refreshToken: string;
}
interface forgotPasswordType {
    email: string;
}
export interface validateOtpType {
    email: string;
    otp: string;
    ref: string;
}

export class Authentication extends BaseAPI {
    public static login(props: loginType): Promise<any> {
        return this.api.post(`${path}/login`, props).then(res => res);
    }
    public static logout(): Promise<any> {
        return this.api.get(`${path}/logout`).then(res => res);
    }
    public static refresh(props: refreshToken): Promise<any> {
        return this.api.post(`${path}/refresh`, props).then(res => res);
    }
    public static getProfile(): Promise<any> {
        return this.api.get(`${path}/profile`).then(res => res);
    }
    public static forgotPassword(props: forgotPasswordType): Promise<any> {
        return this.api.post(`${path}/forgotpassword`, props);
    }
    public static validateOtp(props: validateOtpType): Promise<any> {
        return this.api.post(`${path}/validate-otp`, props).then(res => res);
    }
    public static password(password: string, accessToken: string): Promise<any> {
        return this.api.patch(`${path}/password`, { password: password }, { headers: { Authorization: `Bearer ${accessToken}` } }).then(res => res);
    }
}